
import { timeRangeOptions } from "@/utils/options";


export const templateTypeOptions = [
    { text: 'request a review', id: 'AMAZON_REQUEST_REVIEW' },
    { text: '节假日自动回复', id: 'HOLIDAYS_AUTO_REPLY' },
    { text: '退货关怀', id: 'BAD_REVIEW' },
    { text: '退款关怀', id: 'REFUND' },
    { text: '邀评关怀', id: 'CUSTOMIZE_REQUEST_REVIEW' },
    { text: '自定义类型', id: 'CUSTOMIZE' }
]

export const orderTypeListOptions = [
    { text: '所有类型', id: 'ORDER_TYPE_ALL' },
    { text: '标准订单', id: 'ORDER_TYPE_NORMAL' },
    { text: '多渠道订单', id: 'ORDER_TYPE_MULTICHANNEL' },
    { text: '换货订单', id: 'ORDER_TYPE_REPLACEMENT' },
    { text: 'B2B订单', id: 'ORDER_TYPE_BUSINESS' },
    { text: '推广订单', id: 'ORDER_TYPE_TEST' },
    { text: '促销订单', id: 'ORDER_TYPE_PROMOTION' },
    { text: '退款订单', id: 'ORDER_TYPE_REFUNDED' },
    { text: '退货订单', id: 'ORDER_TYPE_RETURNED' },
    // { text: '运费折扣订单', id: 'ORDER_TYPE_SHIPPING_DISCOUNT' },
]

export const filterUserTimeOptions = [
    { text: '近7天', id: 7 },
    { text: '近15天', id: 15 },
    { text: '近30天', id: 30 },
]

export const orderFulfillmentChannelOptions = [
    { text: '不区分渠道', id: 'ALL' },
    { text: 'FBA', id: 'FBA' },
    { text: 'FBM', id: 'FBM' },
]
let filterSendIntervalArr = [];

for (let index = 7; index < 61; index++) {
    filterSendIntervalArr.push({
        text: index.toString(), id: index
    })
}
export const filterSendIntervalOptions = filterSendIntervalArr;
export const filterOrderOptions = [
    { text: '不排除', id: 'ALL' },
    { text: '已请求评论的订单', id: 'HAS_REQUEST_REVIEW' },
]

export const sendConditionFbaOrderTypeOptions = [
    { text: '订单订购后', id: 'Purchase' },
    { text: '订单发货后', id: 'Shipped' },
    { text: '订单送达后', id: 'Delivery' },
]
let sendConditionLocalTime = [];

for (let index = 0; index < 24; index++) {
    sendConditionLocalTime.push({
        text: `${index < 10 ? '0'+index : index}:00`, id: index
    })
}

export const sendConditionLocalTimeOptions = sendConditionLocalTime

export const viewSetting = [
    {
        prop: 'name',
        label: '视图名称',
        isFormItem: true,
        components() {
            return [{
                name: 'gj-input',
                prop: 'name',
                propsData: {
                    placeholder: '请输入视图名称',
                    style: {
                        width: '256px'
                    }
                }
            }]
        },
        validator: [
            {required: true, message: '请输入视图名称', trigger: 'change'}
        ],
        labelWidth: '120px',
        defaultValue: ''
    }, {
        label: '国家店铺',
        prop: 'countryMarketValue',
        components: [{
            name: 'gj-country-server-select',
            prop: 'countryMarketValue'
        }],
        isFormItem: true,
        labelWidth: '120px',
        defaultValue: {
            countryIds: [],
            marketIds: []
        }
    }, {
        label: '模板类型',
        prop: 'templateType',
        isFormItem: true,
        labelWidth: '120px',
        components: [{
            name: 'gj-select',
            prop: 'templateType',
            propsData: {
                options: templateTypeOptions,
                placeholder: '模板类型',
                width: '200px'
            }
        }],
        defaultValue: ''
    }, {
        label: '创建用户',
        labelWidth: '120px',
        prop: 'userId',
        isFormItem: true,
        components: [{
            name: 'gj-creator-select',
            prop: 'userId',
            propsData: {
                placeholder: '创建用户',
                collapseTags: true,
                style: {
                    width: '200px'
                }
            }
        }],
        defaultValue: []
    }, {
        label: '更新用户',
        labelWidth: '120px',
        prop: 'updateUserId',
        isFormItem: true,
        components: [{
            name: 'gj-creator-select',
            prop: 'updateUserId',
            propsData: {
                placeholder: '更新用户',
                collapseTags: true,
                style: {
                    width: '200px'
                }
            }
        }],
        defaultValue: []
    }, {
        label: '时间范围',
        prop: 'dateRange',
        isFormItem: true,
        labelWidth: '120px',
        components: [{
            name: 'gj-select',
            prop: 'dateType',
            propsData: {
                placeholder: '时间类型',
                options: [
                    { id: 'create', text: '创建时间' },
                    { id: 'update', text: '更新时间' },
                ],
                width: '140px'
            }
        }, {
            name: 'gj-select',
            prop: 'dateRange',
            propsData: {
                placeholder: '时间范围',
                options: timeRangeOptions,
                width: '170px',
                style: {
                    marginLeft: '8px'
                }
            }
        }],
        validator: [
            { required: true, message: '请选择日期', trigger: 'change' }
        ]
    }, {
        prop: 'dateType',
        defaultValue: 'create'
    }
]